import { motion } from "framer-motion";
import { Shield, Eye, TrendingUp } from "lucide-react";

const AboutSection = () => {
  const features = [
    { icon: Shield, title: "Transparency", desc: "Full visibility into your investment cycle, returns, and transaction history." },
    { icon: TrendingUp, title: "Low Risk", desc: "Strategic market analysis with disciplined risk management protocols." },
    { icon: Eye, title: "Security First", desc: "Enterprise-grade encryption and manual withdrawal approvals protect your assets." },
  ];

  return (
    <section id="about" className="py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">
            About PRIME PROFIT
          </h2>
          <p className="mx-auto mt-4 max-w-3xl text-muted-foreground font-body text-lg">
            Prime Profit specializes in short-term crypto trading strategies using BTC and BNB markets.
            Our expert team leverages algorithmic analysis and market intelligence to deliver consistent returns
            within 7-day trading cycles. We emphasize transparency, security, and disciplined low-risk management.
          </p>
        </motion.div>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="rounded-xl border border-gold-dark/30 bg-card p-8 text-center transition-all hover:border-gold/50 hover:glow-gold"
            >
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full gradient-gold">
                <f.icon className="h-7 w-7 text-primary-foreground" />
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold text-gold">{f.title}</h3>
              <p className="mt-3 text-sm text-muted-foreground font-body">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
